module.exports = __webpack_public_path__ + "f5ca3f849efa2240c0dbef4e0ff8ed18.svg";